import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonTextarea, ModalController } from '@ionic/angular';
import SignaturePad from 'signature_pad';
import { GeolocationService } from 'src/app/services/geolocation.service';
import { UserService } from 'src/app/services/user.service';
import { EntregaService } from './../../services/entrega.service';
import { Plugins, CameraResultType, CameraSource } from '@capacitor/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-assinatura',
  templateUrl: './assinatura.component.html',
  styleUrls: ['./assinatura.component.scss'],
})
export class AssinaturaComponent implements OnInit {

  @Input() entrega: any = {};
  @ViewChild('edObservacoes', { static: true }) edObservacoes: IonTextarea;

  image:SafeResourceUrl;
  signpad: SignaturePad;
  assinatura: string;
  confirmed = false;

  constructor(private modalController: ModalController,
              private alertController: AlertController,
              private geoService: GeolocationService,
              private entregaS: EntregaService,
              public userS: UserService,
              private DomSanatizer:DomSanitizer,
              ) { }

  ngOnInit() {
    this.canvas();
    this.edObservacoes.value = this.entrega.obs;
  }

  async tirarfoto(){
    const { Camera } = Plugins;

    const result = await Camera.getPhoto({
     quality: 75,
     source: CameraSource.Camera,
     resultType: CameraResultType.DataUrl,
    });

    this.image = result && result.dataUrl
  }

  canvas() {
    this.signpad = new SignaturePad(document.getElementById('signature-pad') as HTMLCanvasElement, {
      backgroundColor: 'rgb(252, 253, 244)',
      penColor: 'rgb(0, 0, 0)'
    });
  }

  limparCanvas() {
    this.signpad.clear();
  }

  cancelarCanvas() {
    this.entregaS.disableButton.next(false);
    this.dismiss();
  }

  assigned() {
    if (this.signpad.isEmpty()) {
      return;
    }
    this.assinatura = this.signpad.toDataURL('image/jpeg', .3);
    this.geoService.getCurrentPositionAssinatura(this.userS.user.id, true);
    this.confirmed = true;
    this.dismiss();
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
      foto: this.image,
      assinatura: this.assinatura,
      confirmed: this.confirmed,
      obs: this.edObservacoes.value
    });
  }

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Confirmar',
      message: 'Deseja confirmar a entrega?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.assinatura = '';
          }
        }, {
          text: 'OK',
          handler: () => {
            this.assinatura = this.signpad.toDataURL('image/jpeg', .3);
            this.geoService.getCurrentPositionAssinatura(this.userS.user.id, true);
            this.confirmed = true;
            this.dismiss();
          }
        }
      ]
    });

    await alert.present();
  }
}
